import React, { Component } from 'react';
import scanGif from './scan.gif';
import skate from './skate.jpg';
import football from './football.jpg';
import "./About.css"

class About extends Component {
    render() {
            return (
                <div className="container">
                    <div className="row py-lg-5">
                        <div className="col-12 col-md-6">
                            <p> <br/>
                                Aside from coding I ❤️ all things sporty or creative. <br/>  <br/>
                                I practice photography, running, skateboarding and football. I also love to travel and learn new languages. I spent the last 2 years living in France teaching English, honing my French to upper-intermediate and picking up beginner Portuguese.<br/><br/>
                                I bring passion into all my pursuits, giving each endeavor my very best. </p>
                        </div> 
                        <div className="col-12 col-md-2">
                            <img src={skate} alt="Skate" style={{width: '100%', objectFit: 'contain'}}/>
                        </div>
                        <div className="col-12 col-md-2">
                            <img src={scanGif} alt="gif" style={{width: '100%', objectFit: 'contain'}}/>
                        </div>
                        <div className="col-12 col-md-2">
                            <img src={football} alt="Football" style={{width: '100%', objectFit: 'contain'}}/>
                        </div>
                    </div>
                </div>
            );
    } 
} 

export default About;